import { DocumentOfReceive } from "../models/DocumentOfReceive";
import { Product } from "../models/Product";
import { RepromaterialTemplateData } from "./RepromaterialTemplateData";
import { RepromaterialExportTemplate } from "./RepromaterialExportTemplate";
import { Utility } from "../core/Utility";
import { cloneDeep } from "lodash";

export const getRepromaterialOutputTemplate = (
  data: DocumentOfReceive,
  productsFromApi: Product[] = [],
) => {
  return RepromaterialExportTemplate(prepareData(data), productsFromApi);
};

const prepareData = (documentData: DocumentOfReceive) => {
  let date = "";
  let time = "";
  if (documentData.date) {
    if (typeof documentData.date == "string") {
      date = documentData.date;
    } else {
      documentData?.finishedDocumentFirstTime === true
        ? (date = `${
            documentData.date.getDate() < 10 ? "0" : ""
          }${documentData.date.getDate()}.${
            documentData.date.getMonth() < 9 ? "0" : ""
          }${
            1 + documentData.date.getMonth()
          }.${documentData.date.getFullYear()}`)
        : (date = `${
            new Date().getDate() < 10 ? "0" : ""
          }${new Date().getDate()}.${new Date().getMonth() < 9 ? "0" : ""}${
            1 + new Date().getMonth()
          }.${new Date().getFullYear()}`);
    }
  }
  if (documentData.time) {
    if (typeof documentData.time == "string") {
      time = documentData.time;
    } else {
      documentData?.finishedDocumentFirstTime === true
        ? (time = `${
            documentData.time.getHours() < 10 ? "0" : ""
          }${documentData.time.getHours()}:${
            documentData.time.getMinutes() < 10 ? "0" : ""
          }${documentData.time.getMinutes()}`)
        : (time = `${
            new Date().getHours() < 10 ? "0" : ""
          }${new Date().getHours()}:${
            new Date().getMinutes() < 10 ? "0" : ""
          }${new Date().getMinutes()}`);
    }
  }

  const docDate = Utility.parseDocDate(documentData.date);
  const cutoff = new Date(2026, 0, 14);

  const templateData: RepromaterialTemplateData = {
    receptionCode: documentData.documentId ?? "",
    documentNumber: documentData.id ?? "",
    finishedDocumentNumber:
      documentData?.finishedDocumentNumber ??
      documentData.finishedDocumentId ??
      "",
    warehouse: documentData.warehouse?.name ?? "",
    date: date,
    time: time,
    warehouseman: documentData.warehouseman as string,
    /*****Kupac robe******/
    supplierType: documentData.partner?.type ?? "",
    supplierName: documentData.partner?.name ?? "",
    supplierPlace: documentData.partner?.city?.name
      ? documentData.partner?.city?.name
      : "",
    supplierAddress: documentData.partner?.address ?? "",
    supplierIdentificationNumber: documentData.partner?.companyNumber ?? "",
    supplierPib: documentData.partner?.vatNumber ?? "",
    supplierPersonalCodeNumber: documentData.partner?.personalCodeNumber ?? "",
    supplierCode: documentData.partner?.code ?? "",
    /*****Prodavac*****/
    buyerName: "RWA Srbija doo",
    buyerPlace:
      docDate && docDate.getTime() >= cutoff.getTime()
        ? "21201 Rumenka"
        : "11070 Bovi Beograd",
    buyerAddress:
      docDate && docDate.getTime() >= cutoff.getTime()
        ? "Kisački put 3G"
        : "Bulevar Zorana Đinđića 67/17",
    buyerIdentificationNumber: "20405112",
    buyerPib: "105528683",
    /*****Podaci o prevozniku i vozaču******/
    shipperName: documentData.shipper?.name ?? "",
    shipperType: documentData.shipper?.type ?? "",
    shipperPlace: documentData.shipper?.city?.name
      ? documentData.shipper?.city?.name
      : "",
    shipperAddress: documentData.shipper?.address ?? "",
    shipperIdentificationNumber: documentData.shipper?.companyNumber ?? "",
    shipperPib: documentData.shipper?.vatNumber ?? "",
    shipperPersonalCodeNumber: documentData.shipper?.personalCodeNumber ?? "",
    driverName: documentData.driverName ?? "",
    licensePlates: (documentData.vehicleNumber ?? "").toUpperCase(),
    /*******Tudja roba na skladistenju *******/
    foreignProduct: documentData.foreignProduct ? "Da" : "Ne",
    productOwnerName: documentData.productOwner?.name ?? "",
    productOwnerPlace: documentData.productOwner?.city?.name
      ? documentData.productOwner?.city?.name
      : "",
    productOwnerAddress: documentData.productOwner?.address ?? "",
    productOwnerType: documentData.productOwner?.type ?? "",
    productOwnerIdentificationNumber:
      documentData.productOwner?.companyNumber ?? "",
    productOwnerPib: documentData.productOwner?.vatNumber ?? "",
    productOwnerPersonalCodeNumber:
      documentData.productOwner?.personalCodeNumber ?? "",
    /******Podaci o robi, napomena */
    repromaterialProducts: cloneDeep(
      documentData.repromaterialProducts,
    ) as Product[],
    note:
      (documentData.foreignProduct ? "TUĐA ROBA " : "") +
      (documentData.note ?? ""),
    loadingCityName: documentData.loadingCityName ?? "",
    loadingContact: documentData.loadingContact ?? "",
  };

  return templateData;
};
